export default __webpack_public_path__ + "441960c91acf8a2e2ad5daabf51b3871.jpg";